export default __webpack_public_path__ + "static/media/image10.99d183ed.jpg";